export default region => localStorage.getItem('region') === region;
